/* eslint-disable camelcase */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, {
    useCallback, useContext, useEffect, useState,useRef
} from 'react';
import _ from 'lodash';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { UserService,SearchService} from 'gw-capability-gateway';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps, WizardContext } from '@xengage/gw-portals-wizard-react';
import { MLPublicContactsService } from 'gw-capability-quoteandbind';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { MLDisclosureUtil, MLErrorMessageUtil, MLProductCodeUtil } from 'ml-portals-util-js';
import { AddtlInterestDriverComponent, AddtlInterestExcludedDriverComponent } from 'ml-capability-quoteandbind-common-react';
import EsignatureComponent from 'gw-capability-quoteandbind-common-react/components/EsignatureComponent/EsignatureComponent';
import { MLDriverVehicleUtil, MLNotificationBlockUtil, MLWizardNavUtil } from 'ml-portals-util-react';
import { MLModifierComponent, MLScriptComponent } from 'ml-components-common-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { FormModalPopover, platformMessages, QuestionSetComponent } from 'ml-components-platform-react';
import { MLPortalStorageService, MLBundleService } from 'ml-services-common-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import PATrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PATrackEvent';
import { MVR_ERR1, MVR_ERR2, MVR_ERR3 } from '../../../../override/constants/ml-mvr-constants';
import wizardConfig from "../../config/pa-wizard-config.json5";
import metadata from './GatewayAdditionalInformationPreBindPage.metadata.json5';
import messages from './GatewayAdditionalInformationPreBindPage.messages';
import styles from './GatewayAdditionalInformationPreBindPage.module.scss';
import { ScrollToError } from '@jutro/legacy/wizard-next';
import { useModal } from '@jutro/components';


import { AccountService } from 'gw-capability-gateway-policy';

const {
    ML_STORAGE_KEY_PREVIOUS_PREMIUM
} = appConfig;

const BLOCK_QUOTE_UW_ERROR = 'GW_BLOCK_QUOTE_UNDERWRITING_ERROR';
const COVERAGE_IS_REQ = "The coverage term 'Coverage Is' is required"

const GatewayAdditionalInformationPreBindPage = (props) => {
    const { steps: wizardSteps } = wizardConfig;
    const { authHeader } = useAuthentication();
    const wizardContext = useContext(WizardContext); 
    const modalApi = useModal();
    const translator = useTranslator();
    const ADDLINTERESTSUBTYPE = 'PAVhcleAddlInterest';
    const {
        wizardData: submissionVM,
        updateWizardData,
        updateWizardSnapshot,
        goNext,
        steps,
        changeNextSteps,
        currentStep,
        isSkipping
    } = props;
    const { onValidate, isComponentValid } = useValidation('AdditionalInformationPreBindPage');
    const viewModelService = useContext(ViewModelServiceContext);
    const [initialPotentialContact, updateInitialPotentialContact] = useState([]);
    const [errors, setErrors] = useState([]);
    const [showErrors, updateShowErrors] = useState(false);
    const [isValidVin, updateIsValidVin] = useState(false)
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [additionalInterestAvailableCandidatesML, setAdditionalInterestAvailableCandidatesML] = useState([]);
    const [initialSignalResponses, setInitialSignalResponses] = useState([]);
    const [inValidVin, setInValidVin] = useState([]);
    const [goToQuotePageTrigger, setGoToQuotePageTrigger] = useState(false);
    const [questionSetSyncing, setQuestionSetSyncing] = useState(false);
    const [questionSetSyncPromise, setQuestionSetSyncPromise] = useState(null);

    const {nextStepVisited} = MLWizardNavUtil(props);
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const isModernProductPersonalAuto = isModernProduct && MLProductCodeUtil.isPersonalAuto(_.get(submissionVM, "baseData.productCode.value"));
    const isContinueClickedRef =  useRef(false)
     const multipolicyLobCodes = [
    "PAMultiplePolicyHomePolicyNumber_ML",
    "PAMultiplePolicyRentersPolicyNumber_ML",
    "PAMultiplePolicyCondoPolicyNumber_ML",
    "PAMultiplePolicyMobilePolicyNumber_ML",
    "PAMultiplePolicyLandlordPolicyNumber_ML",
    "PAMultiplePolicyLandlordCondoPolicyNumber_ML",
    "PAMultiplePolicyBoatPolicyNumber_ML",
    "PAMultiplePolicyUmbrellaPolicyNumber_ML",
    "PAMulitplePolicyMotorCyclePolicyNumber_Ext",
    "PAMulitplePolicyRecreationalVehPolicyNumber_Ext",
    "PAMulitplePolicyOffRoadVehPolicyNumber_Ext",
  ];
    
    const {
        showProgressDialog,
        hideProgressDialog,
        showErrorModal
    } = MLModalService();

    const {
        clearAlerts,
        clearBlockAlerts,
        addErrorAlert,
        getNumberOfAlerts,
        addWarningAlert,
        getNumberOfAlertsExcludingBlocks
    } = MLNotificationBlockUtil();


    const {
        checkHiDrivers,
        checkPendingMvrOrderStatus,
        setModifierEditMode,
        hasDuplicateSignalPhoneNumbers
    } = MLDriverVehicleUtil();	

    const isGPA = appConfig.portalCode === 'GPA';
    const paModel = submissionVM.lobData.personalAuto.coverables.value;
    const hasNamedNonOwner = paModel.hasNamedNonOwner();
    const primaryDriverEmail = _.get(submissionVM, 'bindData.contactEmail');
    const PA_MODIFIER_PATH = "lobData.personalAuto.modifiers_ML";
    const paModifiers = _.get(submissionVM, PA_MODIFIER_PATH);
    const isEnableEsign_State= _.get(submissionVM,'enableEsign_State.value','')
    const userState = _.get(submissionVM, 'baseData.policyAddress.state.value.code','')
    const isEsignEnabledForState = isEnableEsign_State.split(',').map(state => state.trim()).includes(userState);
    const deliveryType = _.get(submissionVM,'quoteData.offeredQuotes.value[0].commPreference_ML')

    const getSubtype = () => {
        return ADDLINTERESTSUBTYPE;
    };


    paModifiers.lineModifiers.value.forEach((mod, index, arr) => {
      const isYes = mod.chosenTermValue === true;

      mod.savedFromPortal = true;
      mod.updated = true;
      mod.editMode_ML = true;
      mod.isVisible_ML = true;

      if (mod.hasDependentModifier_ML) {
        const dependentMod = arr[index + 1];

        if (
          dependentMod &&
          (dependentMod.codeIdentifier_ML?.includes("PolicyNumber_ML") ||
            dependentMod.codeIdentifier_ML?.includes("PolicyNumber_Ext"))
        ) {
          dependentMod.isVisible_ML = isYes;
          dependentMod.isInputValueRequired_ML = false;
          dependentMod.updated = true;

          if (
            !isContinueClickedRef.current &&
            dependentMod.chosenTermValue === "ManualMPD" ||
            dependentMod.chosenTermValue === "ManualMP"
          ) {
            dependentMod.chosenTermValue = "";
          }

          const baseName =
            dependentMod.name?.replace(" (optional)", "") ||
            "Please enter your policy number";
          dependentMod.name = `${baseName} (optional)`;
        }
      }
    });
       
    useEffect(() => {
        const setInitialSignalResponsesArray = () => {
            const initialValues = getRatedDrivers().map((driver) => {
                const modifiers = driver?.driverModifiers_ML?.modifiers?.value || [];
                return {
                    driverId: driver?.value?.person?.publicID,
                    modifiers: modifiers.map(mod => ({
                        codeIdentifier: mod?.codeIdentifier_ML,
                        chosenTermValue: mod?.chosenTermValue
                    }))
                };
            });
            setInitialSignalResponses(initialValues);
        };

        setInitialSignalResponsesArray();
    }, []);

    const isVinDuplicated = useCallback((currentVehicle) => {
        const vehicles = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicles.children', []);
        const vehicleVin = currentVehicle.vin;
        const vehiclesWithTheSameVin = vehicles ? vehicles.filter(
            (x) => !_.isUndefined(x.vin.value) && x.vin.value === vehicleVin.value
        ) : [];
        return vehiclesWithTheSameVin.length >= 2;
    }, [submissionVM]);

    const isRatedDriver = (driverVM) => {
        return driverVM.type_ML.value.code === 'rated';
    };

    const isExcludedDriver = (driverVM) => {
        return driverVM.type_ML.value.code === 'excluded';
    };

    const isInGA = () => {
        const addressVM = _.get(submissionVM, 'baseData.policyAddress');
        return addressVM.state.value && addressVM.state.value.code === 'GA';
    };

    const isInUT = () => {
        const addressVM = _.get(submissionVM, 'baseData.policyAddress');
        return addressVM.state.value && addressVM.state.value.code === 'UT';
    };

    const isInCO = () => {
        const addressVM = _.get(submissionVM, 'baseData.policyAddress');
        return addressVM.state.value && addressVM.state.value.code === 'CO';
    };

    const isInOR = () => {
        const addressVM = _.get(submissionVM, 'baseData.policyAddress');
        return addressVM.state.value && addressVM.state.value.code === 'OR';
    };

    
    const isPrimaryDriver = (driverVM) => {
        return driverVM.relationshipToInsured_ML.value.code === 'self';
    };

    const isSpouseEmailRequired = () => {
        return submissionVM.value.isPersonalAuto() && isInCO();
    };

    const isExcludedDriverEmailRequired = () => {
        return submissionVM.value.isPersonalAuto() && (isInGA() || isInUT() || isInOR());
    };

    const isEmailAddressVerificationRequired = () => {
        const hasEmailAddress = !_.isUndefined(primaryDriverEmail.value) && primaryDriverEmail.value !== '';
        return !(!hasEmailAddress && _.get(submissionVM, 'quoteData.offeredQuotes.value[0].commPreference_ML') === 'paper');
    };

    const setPrimaryDriverEmail = (driverVM) => {
        driverVM.value.reEnterEmailRequired_ML = isEmailAddressVerificationRequired();
        submissionVM.bindData.reEnterEmailRequired_ML.value = driverVM.value.reEnterEmailRequired_ML;
        if (submissionVM.isBundle_ML.value) {
            const prefillFrom = MLBundleService.getPrefillEmailCandidate();
            if (prefillFrom) {
                _.set(submissionVM, 'bindData.contactEmail.value', prefillFrom.emailAddress);
            }
        }
    };

    const skipOnResumeIf = () => {
        return !!_.get(submissionVM, 'bindData.policyNumber.value') && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding');
    };

    const isVehicleYearPre1981_ML = useCallback((vehicleVM) => {
        const vehicleYearValue = _.get(vehicleVM, 'year.value');
        return vehicleYearValue && vehicleYearValue < 1981;
    }, []);

    const getAdditionalInterestAvailableCandidatesML = useCallback((vehicleVM) => {
        const currentVehicleID = _.get(vehicleVM, 'publicID.value', undefined);
        const availableInsuredCandidates = additionalInterestAvailableCandidatesML.filter((candidate) => 
            candidate.vehiclesAvailableForPAAdditionalInterest_ML.some((vehicleID) => 
                vehicleID === currentVehicleID
            )
        );
        return availableInsuredCandidates;
    }, [additionalInterestAvailableCandidatesML]);


    useEffect(() => { 
        if (isGPA) {
            UserService.getCurrentUser(authHeader).then((user) => {
                PATrackEvent('Issuance Step Reached', false, submissionVM, user, { step: 'Additional Info Prebind'});
            });
        }
    }, []);

    useEffect(() => {
        if (MLDisclosureUtil.isRequotedAfterMvr(submissionVM.quoteID.value)) {
            const index = _.findIndex(
                steps,
                ({ mlStepName }) => mlStepName === 'paVeracityCheck'
            );
            if (index > 0) {
                const remainingSteps = _.slice(steps, index);
                changeNextSteps(remainingSteps);
            }
            goNext();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isSkipping || (isSkipping && !skipOnResumeIf())) {
            MLPublicContactsService.getMortgageeContacts(authHeader).then((data) => {
                updateInitialPotentialContact(data);
            });

            LoadSaveService.getAdditionalInterestCandidatesML(submissionVM.quoteID.value, authHeader).then((candidates) => {
                setAdditionalInterestAvailableCandidatesML(candidates);
            });

            _.set(submissionVM, 'lobData.personalAuto.coverables.addInterestTypeCategory', getSubtype());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isSkipping || (isSkipping && !skipOnResumeIf())) {
            const vehiclesVM = submissionVM.lobData.personalAuto.coverables.vehicles.children;
            vehiclesVM.map((vehicleVM) => {
                if (!vehicleVM.additionalInterests.value) {
                    vehicleVM.additionalInterests.value = [];
                }
                vehicleVM.isVinRequired_ML.value = true;
                
                vehicleVM.isSerialNumberRequired_ML.value = true;
                return vehicleVM;
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setTimeout(()=>{
            const element = document.getElementById("gatewayNamedNonOwner");
            if(element){
                element.focus();
            }
        }, 100)
  }, []);

  const updateInValidVin = (index) => {
    
    if(!inValidVin.includes(index)){
      setInValidVin((prev) => [...prev, index])
    }
  }
 
  const removeInValidVin = (index) => {
    if(inValidVin.includes(index)){
      const latestInvalidVin = inValidVin.filter((invalid)=> invalid !== index)
      
      setInValidVin(latestInvalidVin)
    }
  }

    useEffect(() => {
        if (!isSkipping || (isSkipping && !skipOnResumeIf())) {
            const driversVM = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers');

            driversVM.forEach((driver) => {
                if (driver.value) {
                    driver.value.reEnterEmailRequired_ML = true;
                }
            });

            driversVM.forEach((driver) => {
                if (driver.value) {
                    driver.value.storedEmailAddress_ML = _.get(driver, 'value.person.emailAddress_ML');

                    if (driver.value.spouseID_ML && isSpouseEmailRequired()) {
                        driver.value.spouseEmailRequired_ML = true;
                    }

                    if (isExcludedDriver(driver) && isExcludedDriverEmailRequired()) {
                        isInUT() ? driver.value.excludedDriverEmailRequired_ML = false : driver.value.excludedDriverEmailRequired_ML = true;
                    }

                    if (isExcludedDriver(driver)) {
                        driver.value.isAgeFirstLicensedRequired_ML = true;
                    }

                    if (isPrimaryDriver(driver)) {
                        setPrimaryDriverEmail(driver);
                    }

                    const addressVM = _.get(submissionVM, 'baseData.policyAddress');

                    if (driver.requiresProof_ML.value === true) {
                        driver.value.isCFRInfoRequired_ML = true;

                        if ((driver.requestingState_ML.value === null || typeof driver.requestingState_ML === 'undefined') && addressVM !== null) {
                            const stateExistsInTypeList = driver.requestingState_ML.aspects.availableValues.some((state) => {
                                return state.code === _.get(submissionVM, 'lobData.personalAuto.policyAddress_ML.state.value.code', undefined);
                            });

                            driver.requestingState_ML = stateExistsInTypeList ? addressVM.state.value : null;
                        }
                    }
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const writeValue = useCallback((value, path) => {
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, path, value);
        updateWizardData(newSubmissionVM);
    }, [submissionVM, updateWizardData, viewModelService]);

    const updateSubmissionVM = useCallback(() => {
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    const generateVehiclesOverrides = useCallback(() => {
        const vehicles = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicles.children', []);

        const overrides = vehicles.map((vehicle, index) => {
            return {
                [`vehicleInfoComponent${index}`]: {
                    value: vehicle,
                    submissionVM,
                    isVinDuplicated,
                    index,
                    onValueChange: writeValue,
                    quoteID: submissionVM.quoteID,
                    updateVehicleDetails: updateSubmissionVM,
                    initialPotentialContact: initialPotentialContact,
                    showValidationErrors: showErrors,
                    onValidate,
                    isGpa: true,
                    updateIsValidVin,
                    updateInValidVin,
                    removeInValidVin,
                    additionalInterestAvailableCandidatesML: getAdditionalInterestAvailableCandidatesML(vehicle)
                }
            };
        });

        return Object.assign({}, ...overrides);
    }, [getAdditionalInterestAvailableCandidatesML, initialPotentialContact, isVinDuplicated, onValidate, showErrors, submissionVM, updateSubmissionVM, writeValue]);

    const getPrimaryDriverSpouse = useCallback(() => {
        const driversPath = 'lobData.personalAuto.coverables.drivers.children';
        const drivers = _.get(submissionVM, driversPath, []);
        const primaryDriverSpouse = _.filter(drivers, (driver) => {
            return driver.relationshipToInsured_ML.value.code === 'spouse';
        });
        return primaryDriverSpouse;
    }, [submissionVM]);

    const updatePrimaryDriverSpouseEmail = useCallback((email) => {
        const driversPath = 'lobData.personalAuto.coverables.drivers.children';
        const drivers = _.get(submissionVM, driversPath, []);
        const primaryDriverSpouse = _.filter(drivers, (driver) => {
            return driver.relationshipToInsured_ML.value.code === 'spouse';
        });
        const spouseIndex = drivers.indexOf(primaryDriverSpouse[0]);
        _.set(submissionVM, `${driversPath}.${spouseIndex}.person.emailAddress_ML.value`, email);
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    const validateEmailAddress = (accountContactDetailsVm) => {
        const account = accountContactDetailsVm;
        let emailAddress1 =  _.get(account, 'emailAddress_ML.value')
        if(emailAddress1){
            emailAddress1=emailAddress1.trim();
        }
        let isValidEmailEntred =  /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(emailAddress1)
        if(isValidEmailEntred){
            const checkEmailVerified_Ext = AccountService.checkEmailVerified_Ext(
                emailAddress1,
                authHeader
            );
            showProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
            checkEmailVerified_Ext.then((res) => {
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                console.log("Email verification Api Called");
                if(res == true){
                    _.set(account, 'emailVerified_Ext.value', true);
                    _.set(account, 'emailAddress_ML.value', emailAddress1);
                    if(_.get(account, 'value.accountHolder') === true){
                        _.set(submissionVM, 'bindData.contactEmail.value', emailAddress1);
                    }
                }
                else{
                    _.set(account, 'emailVerified_Ext.value', false);
                    _.set(account, 'emailAddress_ML.value', emailAddress1 + " ");
                }
            }).catch((e) => {
                clearBlockAlerts('invalidEmail');
                addWarningAlert(translator(messages.invalidEmail), 'invalidEmail');
                _.set(account, 'emailAddress_ML.value', emailAddress1);
                _.set(submissionVM, 'bindData.contactEmail.value', emailAddress1);
                _.set(account, 'emailVerified_Ext.value', false);
                hideProgressDialog(platformMessages.loading, checkEmailVerified_Ext, true);
                console.log(e);
                window.scrollTo(0, 0);
            });
        }
        
    };

    const getRatedDrivers = () => {
        const driversPath = 'lobData.personalAuto.coverables.drivers.children';
        const drivers = _.get(submissionVM, driversPath, []);

        const getDriverSortPriority = (driverVM) => {
            if (isPrimaryDriver(driverVM)) {
                return 0;
            }
            switch (driverVM.type_ML.value.code) {
                case 'rated':
                    return 1;
                case 'household':
                    return 2;
                case 'excluded':
                    return 3;
                default:
                    return 9;
            }
        };

        const getSortedDriversVM = (driversToSort) => {
            return driversToSort.sort((drv1VM, drv2VM) => {
                const drv1Priority = getDriverSortPriority(drv1VM);
                const drv2Priority = getDriverSortPriority(drv2VM);

                if (drv1Priority < drv2Priority) {
                    return -1;
                }

                if (drv1Priority > drv2Priority) {
                    return 1;
                }

                return 0;
            });
        };

        const driversToSort = [...drivers];
        const sortedDrivers = getSortedDriversVM(driversToSort);

        const ratedDrivers = _.filter(
            sortedDrivers,
            (driver) => {
                return driver.type_ML.value.code === 'rated';
            }
        );
        return ratedDrivers;
    }

    const isFieldDefaultedByHvq = useCallback((inputID) => {
        return submissionVM.value.isConsumerCompRater()
            && MLHVQDefaultFieldsUtil.isFieldDefaultedByHVQ(submissionVM.value.compRaterVendorName_ML, inputID, currentStep.mlStepName);
    }, [currentStep.mlStepName, submissionVM.value]);

    //
    // Modifier
    //
    const disableValidationForDependentModifiers = (mod) => {
        if (mod && mod.hasDependentModifier_ML.value) {
            getRatedDrivers().forEach((driver) => {
                if (!_.isEmpty(driver.driverModifiers_ML)) {
                    driver.driverModifiers_ML.modifiers.forEach((modifier) => {
                        if (modifier.isDependentModifier_ML) {
                            modifier.editMode_ML = false;
                        }
                    });
                }
            });
        }
    };

    const initVehicleValue = (vehicle) => {
        if (!vehicle.value_ML || vehicle.value_ML.amount === 0) {
            vehicle.value_ML = {};
        }
        vehicle.tempID = (vehicle.publicID) ? vehicle.publicID : vehicle.tempID;
    };

    const updateModifiers = (mod) => {
        const setEditMode = (editMode) => submissionVM.value.lobData.personalAuto.coverables.drivers.forEach((driver) => {
            driver.editMode_ML = editMode;
            driver.isLicenseNumberRequired_ML = editMode;
        });

       disableValidationForDependentModifiers(mod);
        // Disable validation so we can update the model and the driver modifiers with it
        setEditMode(false);
        const submissionLoadPromise = LoadSaveService.updateModifiers(submissionVM.value, authHeader);
        showProgressDialog(platformMessages.syncing, submissionLoadPromise, true);
        submissionLoadPromise.then((qdd) => {
            submissionVM.value.lobData.personalAuto.coverables.drivers.length = 0;
            const sortedDrivers = _.sortBy(qdd.lobData.personalAuto.coverables.drivers, (driver) => {
                if (driver.publicID) {
                    return _.toInteger(driver.publicID.split(':')[1]);
                }
                return undefined;
            });
            sortedDrivers.forEach((driver) => {
                if (driver.person) {
                    driver.person = submissionVM.value.findPerson(submissionVM.value, driver.person);
                }
            });
            _.set(submissionVM, 'value.lobData.personalAuto.coverables.drivers', sortedDrivers);

            if (mod?.codeIdentifier_ML?.value === 'PADriverSignalProgram_Ext') {
                submissionVM.value.lobData.personalAuto.coverables.vehicles.length = 0;
                qdd.lobData.personalAuto.coverables.vehicles.forEach((updatedVehicle, index) => {
                    initVehicleValue(updatedVehicle);
                    submissionVM.value.lobData.personalAuto.coverables.vehicles.push(updatedVehicle);
                });
            }

        }, (error) => {
            console.error(error);
            if (!submissionVM.aspects.valid || !submissionVM.aspects.subtreeValid) {
                updateShowErrors(true);
                setTimeout(()=>{
                    setErrorTimestamp(errorTimestamp+1);
                }, 500);
                return false;
            }
        }).finally(() => {
            setModifierEditMode(submissionVM.value.lobData.personalAuto.coverables.drivers, true);
            setEditMode(true);
            updateWizardData(submissionVM);
        });
    };

    const generateDriversOverrides = useCallback(() => {
        const driversPath = 'lobData.personalAuto.coverables.drivers.children';
        const drivers = _.get(submissionVM, driversPath, []);
        const policyAddress = _.get(submissionVM, 'baseData.policyAddress');

        const getDriverSortPriority = (driverVM) => {
            if (isPrimaryDriver(driverVM)) {
                return 0;
            }
            switch (driverVM.type_ML.value.code) {
                case 'rated':
                    return 1;
                case 'household':
                    return 2;
                case 'excluded':
                    return 3;
                default:
                    return 9;
            }
        };

        const getSortedDriversVM = (driversToSort) => {
            return driversToSort.sort((drv1VM, drv2VM) => {
                const drv1Priority = getDriverSortPriority(drv1VM);
                const drv2Priority = getDriverSortPriority(drv2VM);

                if (drv1Priority < drv2Priority) {
                    return -1;
                }

                if (drv1Priority > drv2Priority) {
                    return 1;
                }

                return 0;
            });
        };

        const driversToSort = [...drivers];
        const sortedDrivers = getSortedDriversVM(driversToSort);

        const ratedDrivers = _.filter(
            sortedDrivers,
            (driver) => {
                return driver.type_ML.value.code === 'rated';
            }
        );
        const excludedDrivers = _.filter(
            sortedDrivers,
            (driver) => {
                return driver.type_ML.value.code === 'excluded';
            }
        );
        const getIndexFromDriverList = (specificDriver) => {
            const driverIndex = drivers.indexOf(specificDriver);
            return driverIndex;
        };

        const ratedOverrides = ratedDrivers.map((driver, index) => {
            return {
                [`ratedDriverComponent${index}`]: {
                    value: driver,
                    index,
                    policyAddress,
                    path: `${driversPath}.${getIndexFromDriverList(driver)}`,
                    primaryDriverSpouse: getPrimaryDriverSpouse(),
                    onValueChange: writeValue,
                    updatePrimaryDriverSpouseEmail,
                    showValidationErrors: showErrors,
                    onValidate,
                    submissionVM,
                    updateDrivers: updateSubmissionVM,
                    isGpa: true,
                    canEditEmailFields: _.get(submissionVM, 'canEditCommunicationsFields_Ext.value'),
                    validateEmailAddress,
                    isFieldDefaultedByHvq,
                    updateModifiers,
                    isModernProduct: _.get(submissionVM, "isModernProduct_Ext.value", false)
                }
            };
        });

        const excludedOverrides = excludedDrivers.map((driver, index) => {
            return {
                [`excludedDriverComponent${index}`]: {
                    value: driver,
                    index,
                    policyAddress,
                    path: `${driversPath}.${getIndexFromDriverList(driver)}`,
                    onValueChange: writeValue,
                    showValidationErrors: showErrors,
                    onValidate,
                    isGpa: true,
                    canEditEmailFields: _.get(submissionVM, 'canEditCommunicationsFields_Ext.value'),
                    isModernProduct: _.get(submissionVM, "isModernProduct_Ext.value", false),
                    submissionVM
                }
            };
        });
        return Object.assign({}, ...ratedOverrides, ...excludedOverrides);
    }, [getPrimaryDriverSpouse, onValidate, showErrors, submissionVM, updatePrimaryDriverSpouseEmail, updateSubmissionVM, writeValue]);

    const getriverListOfType = (type) => {
        const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.children', []);
        const ratedDrivers = _.filter(
            drivers,
            (driver) => {
                return driver.type_ML.value.code === type;
            }
        );
        return ratedDrivers;
    };

    const hasPALeaseLoanCovButChangedOwnership = (vehicleVM) => {
        const vehicle = vehicleVM.value;
        return vehicle.hasPALeaseLoanCov_ML
            && vehicle.financeCategory_ML !== vehicle.orgFinanceCategory_ML;
    };

    const isFinanceWithoutPALeaseLoanCovButNoLienHolder = (vehicleVM) => {
        const vehicle = vehicleVM.value;
        return vehicle.hasPALeaseLoanCov_ML !== true
            && vehicle.financeCategory_ML === 'financed'
            && vehicle.additionalInterests.filter((addInt) => addInt.type === 'LIEN').length === 0;
    };

    const isOwnedButWithLienHolderLessor = (vehicleVM) => {
        const vehicle = vehicleVM.value;
        return vehicle.financeCategory_ML === 'owned'
            && _.filter(vehicle.additionalInterests, (addInt) => {
                return addInt.type === 'LIEN' || addInt.type === 'LEASINGCOMPANY';
            }).length !== 0;
    };

    const isLeaseButNoLessor = (vehicleVM) => {
        const vehicle = vehicleVM.value;
        const addLeasingCompany = _.filter(vehicle.additionalInterests, (addInt) => addInt.type === 'LIEN' || addInt.type === "TRUST_ML" || addInt.type === 'LEASINGCOMPANY' ||  addInt.type === 'LESSOR' );
        return vehicle.financeCategory_ML === 'leased'
            && addLeasingCompany.length === 0;
    };

    const showVehicleOwnershipErrorMessages = (vehiclesVM) => {
        const errorMessages = [];

        clearAlerts();
        setErrors([]);

        if (!!vehiclesVM && vehiclesVM.length > 0) {
            vehiclesVM.forEach((vehicleVM) => {
                let errorMsg = null;
                let errorName = null;

                if (hasPALeaseLoanCovButChangedOwnership(vehicleVM)) {
                    errorMsg = translator(messages.hasPALeaseLoanCovButChangedOwnership);
                    errorName = 'removeLeaseLoanGap';
                }
                if (isFinanceWithoutPALeaseLoanCovButNoLienHolder(vehicleVM)) {
                    errorMsg = translator(messages.isFinanceWithoutPALeaseLoanCovButNoLienHolderOrLeaseButNoLessor);
                    errorName = 'noInterestedPartyInformation';
                }
                if (isLeaseButNoLessor(vehicleVM)) {
                    errorMsg = translator(messages.isLeaseButNoLessor);
                    errorName = 'leasedWithNoLeasingcompany';
                }
                if (isOwnedButWithLienHolderLessor(vehicleVM)) {
                    errorMsg = translator(messages.isOwnedButWithLienHolderLessor);
                    errorName = 'updateOwnedFinanceLeasedField';
                }
                if (!!errorMsg && !!errorName) {
                    addErrorAlert(errorMsg, errorName);
                    errorMessages.push(errorMsg);
                } else if(errorName) {
                    clearBlockAlerts(errorName);
                }
            });
        }
        setErrors(errorMessages);
        return errorMessages;
    };

    const isCategoryTrailerGolfCartOrLowSpeedOrOtherPersonal = (vehicleVM) => {
        switch (vehicleVM.category_ML.value.code) {
            case 'trailer':
            case 'registered_golf_cart':
            case 'low_speed_vehicle':
            case 'Other_Personally_Registered':
                return true;
            default:
                return false;
        }
    };

    const getNextStepText = () => {
        return (
            <FormattedMessage
                {...messages.continueText}
                values={{
                    reviewForAnyAdditionalActivityText: (
                        <strong>{translator(messages.reviewForAnyAdditionalActivityText)}</strong>
                    ),
                    mvrsMayBeRun: (
                        <strong>{translator(messages.mvrsMayBeRun)}</strong>
                    )
                }}
            />
        );
    }

    const generateErrorsOverrides = () => {
        const overrides = errors.map((error, index) => {
            return {
                [`error${index}`]: {
                    messageProps: {
                        error: error
                    }
                }
            };
        });

        return Object.assign({}, ...overrides);
    };
         const checkQuestionSetSync = (serviceCall) => {
       let updatePromise;
       if (questionSetSyncing && questionSetSyncPromise) {
         console.log("Waiting for questionSetSyncing to finish...");
         updatePromise = questionSetSyncPromise.then(() => {
           const promise = serviceCall();
           setTimeout(() => {
             showProgressDialog(
               platformMessages.syncingQuestions,
               promise,
               true,
             );
           }, 0);
           return promise;
         });
       } else {
         updatePromise = serviceCall();
         setTimeout(() => {
           showProgressDialog(
             platformMessages.syncingQuestions,
             updatePromise,
             true,
           );
         }, 100);
       }
       setQuestionSetSyncing(true);
       setQuestionSetSyncPromise(updatePromise);
       return updatePromise;
     };
      const checkOwnsResidenceModifier = (mod, copiedView) => {
        if (mod.patternCode.value === "z70hmvhmucbde2eo899j9kmgjdb") {
          if (mod.chosenTermValue.value) {
            if (
              !copiedView.lobData.personalAuto.modifiers_ML
                .yearsAtCurrentResidence
            ) {
              copiedView.lobData.personalAuto.modifiers_ML.yearsAtCurrentResidence = 0;
            }
          }
        }
      };

 const syncModifiers = (submissionData, mlModifier) => {
   submissionData.forEach((mod) => {
     const oldMod = mlModifier.value.find((value) => {
       return value.patternCode === mod.patternCode;
     });
     _.set(mod, "chosenTermValue", oldMod ? oldMod.chosenTermValue : null);
     if (mod.valueType === "boolean") {
       _.set(mod, "chosenTermValue", oldMod ? oldMod.chosenTermValue : false);
     }
     if (!multipolicyLobCodes.includes(mod.codeIdentifier_ML)) {
       _.set(mod, "savedFromPortal", true);
       _.set(mod, "editMode_ML", true);
     }
   });
   _.set(mlModifier, "value", submissionData);
 };

   const syncModifierDependentQuestions = (submissionData, mlModifier) => {
     if (mlModifier.yearsAtCurrentResidence) {
       mlModifier.yearsAtCurrentResidence.value =
         submissionData.yearsAtCurrentResidence;
     }
   };

      const updateAdditionalInfoPrebindModifier = async (mod) => {
       const codeIdentifier = _.get(mod, 'codeIdentifier_ML.value') || _.get(mod, 'codeIdentifier_ML');
       const enteredValue = _.get(mod, 'chosenTermValue.value') ?? _.get(mod, 'chosenTermValue');
       const isPolicyNumberModifier = multipolicyLobCodes.includes(codeIdentifier);
       const isBlankPolicyNumber = isPolicyNumberModifier && ( enteredValue === undefined || enteredValue === null || String(enteredValue).trim() === '' );
    if (isPolicyNumberModifier) {
        _.set(mod, 'chosenTermValue.value', isBlankPolicyNumber ? '' : enteredValue);
        _.set(mod, 'isInputValueRequired_ML.value', false);
        _.set(mod, 'editMode_ML.value', true);
        _.set(mod, 'savedFromPortal.value', true);
        _.set(mod, 'updated.value', true);

    } else {
        _.set(mod, "updated.value", true);
    }
        const validMods = [];
        const copiedModel = viewModelService.clone(submissionVM);

        for (let i = 0; i < paModifiers.lineModifiers.length; i += 1) {
          const modifier = paModifiers.lineModifiers.children[i];
          checkOwnsResidenceModifier(modifier, copiedModel);
          const modifierCode = _.get(modifier, 'codeIdentifier_ML.value') || _.get(modifier, 'codeIdentifier_ML');
          const isPolicyNumber = multipolicyLobCodes.includes(modifierCode);
           if (isPolicyNumber || modifier.aspects.subtreeValid) {
            validMods.push(modifier.value);
          }
        }
        _.set(
          copiedModel,
          "lobData.personalAuto.modifiers_ML.lineModifiers",
          validMods,
        );
 

        const updateModifiersPromise = checkQuestionSetSync(() =>
          LoadSaveService.updateModifiers(copiedModel.value, authHeader),
        );

        updateModifiersPromise
          .then((submissionData) => {
            syncModifiers(
              submissionData.lobData.personalAuto.modifiers_ML.lineModifiers,
              paModifiers.lineModifiers,
            );
            syncModifierDependentQuestions(
              submissionData.lobData.personalAuto.modifiers_ML,
              paModifiers,
            );
            paModifiers.lineModifiers.children.forEach((modifier) => {
              const modifierCode =
                _.get(modifier, "codeIdentifier_ML.value") ||
                _.get(modifier, "codeIdentifier_ML");

              if (multipolicyLobCodes.includes(modifierCode)) {
                _.set(modifier, "isInputValueRequired_ML.value", false);
              }
            });
 
            updateWizardData(submissionVM);
          })
          .catch((e) => {
            console.error(e);
          });
      };

    const overrideProps = {
        paAdditionalInfoIterable: {
            visible: !hasNamedNonOwner,
            data: submissionVM.lobData.personalAuto.coverables.vehicles.children,
        },
        additionalInfoRatedDriverIterable: {
            data: getriverListOfType('rated')
        },
        additionalInfoExcludedDriverIterable: {
            data: getriverListOfType('excluded')
        },
        nextDescription: {
            content: getNextStepText()
        },
        hasNamedNonOwnerContainer: {
            visible: hasNamedNonOwner
        },
        mlScriptComponent: {
            mlScript: _.get(submissionVM, 'script_ML.value', [])
        },
        stickyContinueSection: {
            defaultContinueSectionId: 'footer',
            nextDescription: getNextStepText()
        },
        errorsIterable: {
            data: errors
        },
        modifierComponent: {
            modifier: paModifiers.lineModifiers,
            updateModifier: updateAdditionalInfoPrebindModifier,
            onValidate: onValidate,
            showValidationErrors: showErrors,
            visible: !_.isUndefined(paModifiers) && isModernProductPersonalAuto,
            showPopover: false,
            submissionVM,
            updateWizardData,
            handleOnChange: true,
            isAdditionalInfoPrebind: true          
    },

        ...generateVehiclesOverrides(),
        ...generateDriversOverrides(),
        ...generateErrorsOverrides(),
        esignContainer: {
            visible: isModernProduct && isEsignEnabledForState,
            model: submissionVM,
            updateWizardData,
            product: "personalAuto"
        }
    };

    const saveCurrentPremium = () => {
        let selectedQuote;
        if (submissionVM.bindData && submissionVM.bindData.chosenQuote && submissionVM.quoteData && 
            submissionVM.quoteData.offeredQuotes) {
            const selectedQuoteId = submissionVM.bindData.chosenQuote.value;
            selectedQuote = submissionVM.quoteData.offeredQuotes.value.find((q) => q.publicID === selectedQuoteId);
        }
        if (selectedQuote) {
            const jsonData = [{
                publicID: selectedQuote.publicID,
                branchCode: selectedQuote.branchCode,
                monthlyPremium: selectedQuote.premium.monthlyPremium,
                total: selectedQuote.premium.total
            }];
            MLPortalStorageService.store(submissionVM.quoteID.value, null, ML_STORAGE_KEY_PREVIOUS_PREMIUM, JSON.stringify(jsonData), authHeader);
        }
    };


    const shouldShowDisclosures = () => {
        const getSelectedQuote = () => {
            const selectedQuoteId = _.get(submissionVM, 'bindData.chosenQuote.value');
            const offeredQuotes = _.get(submissionVM, 'quoteData.offeredQuotes.value', []);
            return offeredQuotes.find((q) => q.publicID === selectedQuoteId);
        };

        let violations = [];
        const selectedQuote = getSelectedQuote();
        if (selectedQuote === undefined) {
            return false;
        }

        const populateViolations = () => {
            const drivers = submissionVM.lobData.personalAuto.coverables.drivers.value;
            violations = drivers.flatMap((driver) => driver.disclosures_ML.violations);
        };

        const foundViolationsFromMVR = () => {
            return violations.some((v) => v.undisclosedActivity_ML === true);
        };

        const checkHIDriverMVR = () => {
            const drivers = submissionVM.lobData.personalAuto.coverables.drivers.value;
            if( checkHiDrivers (drivers) &&  checkPendingMvrOrderStatus(drivers))
                return true;
            return false;    
        }

        const getFormerCostsAndGoNext = () => {
            const costsAreEqual = (costA, costB) => {
                if (costA && costB) {
                    return costA.amount === costB.amount && costA.currency === costB.currency;
                }
                return true;
            };

            let premiumsMatch = false;

            const storagePromise = MLPortalStorageService.retrieve(submissionVM.quoteID.value, null, ML_STORAGE_KEY_PREVIOUS_PREMIUM, authHeader);
            
            showProgressDialog(platformMessages.synchronizingQuote, storagePromise);
            storagePromise.then((response) => {
                if (response) {
                    const parsed = typeof response === "string" ? JSON.parse(response) : response;
                    const formerCosts = Array.isArray(parsed) ? parsed : [];
                    const matchingQuote = formerCosts.find((quote) =>
                        selectedQuote.branchCode
                            ? quote.branchCode === selectedQuote.branchCode
                            : quote.publicID === selectedQuote.publicID
                    );

                    if (matchingQuote) {
                        premiumsMatch = costsAreEqual(matchingQuote.monthlyPremium, selectedQuote.premium.monthlyPremium) || costsAreEqual(matchingQuote.total, selectedQuote.premium.total);
                    }
                }
            });
            storagePromise.finally(() => {
                MLDisclosureUtil.setRequoteAfterMvr(submissionVM.quoteID.value, true);
                return !premiumsMatch;
            });
        };

        populateViolations();
        if (foundViolationsFromMVR()) {
            return true;
        };
        if(checkHIDriverMVR()){
            return true;
        };
        return getFormerCostsAndGoNext();
    };

    const checkVehicle = (vehicle) => {
        const category = !isCategoryTrailerGolfCartOrLowSpeedOrOtherPersonal(vehicle)
        const isNotValidVin = !isValidVin && !isVehicleYearPre1981_ML(vehicle);
        return category && isNotValidVin;
    }

    const sortVehicleInterests_Ext = (vehicleVM) => {
        const additionalInterests = _.get(vehicleVM, 'additionalInterests.value', []);
        const sortedInterests = _.sortBy(additionalInterests, (interest) => {
            if (interest.publicID) {
                return _.toInteger(interest.publicID.split(':')[1]);
            }
            return undefined;
        });
        _.set(vehicleVM, 'additionalInterests.value', sortedInterests);
        return vehicleVM;
    };

    const sortAdditionalInterestsByPublicID_Ext = () => {
        const vehiclesVM = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicles.children', []);
        vehiclesVM.forEach((vehicle, idx) => {
            const vehicleWithSortedInterests = sortVehicleInterests_Ext(vehicle);
            _.set(submissionVM, `lobData.personalAuto.coverables.vehicles.children.${idx}.value`, vehicleWithSortedInterests.value);
        });
    };

    const removeEmailValidationError = () => {
        if(_.get(account, 'emailAddress_ML.value') === ' ')
            _.set(account, 'emailAddress_ML.value', undefined);
    }

    const checkForEmailValidationError = () => {
        const driversPath = 'lobData.personalAuto.coverables.drivers.children';
        const drivers = _.get(submissionVM, driversPath, []);
        const driversToSort = [...drivers];
        const sortedDrivers = driversToSort;
        const ratedDrivers = _.filter(
            sortedDrivers,
            (driver) => {
                return driver.type_ML.value.code === 'rated';
            }
        );
        let errorReason = false;
        const EmailValidationErr = ratedDrivers.map((driver, index) => {
            if(driver.person.emailAddress_ML.value === " "){
                driver.person.emailAddress_ML.value=undefined;
                errorReason=true;
            }
        })
        return errorReason;
    }

    const checkForUniqueLicenseNumbers = () => {
        clearBlockAlerts('duplicateLicense');

        const drivers = submissionVM.lobData.personalAuto.coverables.drivers.value.filter((d) => {
            return d.licenseNumber && (d.type_ML === 'rated' || d.type_ML === 'excluded');
        });
        const seen = new Set();
        let hasDuplicate = false;

        drivers.forEach((d) => {
            if (seen.has(d.licenseNumber)) {
                hasDuplicate = true;
            } else {
                seen.add(d.licenseNumber);
            }
        });

        if(hasDuplicate) {
            addErrorAlert(messages.duplicateLicenseError, 'duplicateLicense');
            
            return false;
        }

        return true;
    };

    const checkForMissingAnnualMileage = () => {
        clearBlockAlerts('annualMileage');

        const vehicles = submissionVM.lobData.personalAuto.coverables.vehicles.value || [];

        const hasMissingMileage = vehicles.some(v => {
            const annualMileageMissing =
                v.annualMileage === undefined ||
                v.annualMileage === null ||
                v.annualMileage === '';

            const vendorAnnualMileageMissing =
                v.vendorAnnualMileage_ML === undefined ||
                v.vendorAnnualMileage_ML === null ||
                v.vendorAnnualMileage_ML === '';

            const isPrivatePassengerNP = v.category_ML === 'private_passenger_np'

            // Error only when Private Passenger and BOTH Annual Mileage and Vendor Mileagea are missing
            return annualMileageMissing && vendorAnnualMileageMissing && isPrivatePassengerNP;
        });

        if (hasMissingMileage) {
            addErrorAlert(messages.missingAnnualMileage, 'annualMileage');
            return true;
        }

        return false;
    };

    const removeAdditionalInterestEmailErrors = () => {
        if (submissionVM.baseData.productCode.value === "PersonalAuto") {
            submissionVM.lobData.personalAuto.coverables.vehicles.value = submissionVM.lobData.personalAuto.coverables.vehicles.value.map(vehicle => {
                if (vehicle && vehicle.additionalInterests) {
                    vehicle.additionalInterests = vehicle.additionalInterests.map(interest => {
                        if (interest && interest.policyAdditionalInterest && interest.policyAdditionalInterest.emailAddress1 === ' ') {
                            interest.policyAdditionalInterest.emailAddress1 = undefined;
                        }
                        return interest;
                    });
                }
                return vehicle;
            });
        }
    }    

    const checkForMandatoryFieldForSignalProgram = () => {
        let isValid = true;
        getRatedDrivers().forEach((driver) => {
            const modifiersList = driver?.driverModifiers_ML?.modifiers;
            if (Array.isArray(modifiersList.value)) {
                modifiersList.value.forEach((modifier) => {
                    if (modifier.codeIdentifier_ML === "PADriverSignalProgramPhoneNumber_Ext"){
                        if(modifier?.chosenTermValue === null || modifier?.chosenTermValue === undefined || modifier?.chosenTermValue === ""){
                            isValid = false;
                            modifier.isInputValueRequired_ML = true;
                        }
                        if (modifier?.chosenTermValue && modifier?.chosenTermValue?.length !== 10) {
                            isValid = false;
                        }
                    }
                });
            }
        });
        return isValid;
    };

    const hasSignalResponsesChanged = () => {
        return getRatedDrivers().some((driver) => {
            const driverId = driver?.value?.person?.publicID;
            const currentModifiers = driver?.driverModifiers_ML?.modifiers?.value || [];

            const initial = initialSignalResponses.find(item => item?.driverId === driverId);
            const initialModifiers = initial?.modifiers || [];

            return currentModifiers.some((mod) => {
                const initialMod = initialModifiers.find(im => im.codeIdentifier === mod?.codeIdentifier_ML);
                return initialMod?.chosenTermValue !== mod?.chosenTermValue;
            });
        });
    };
    
    const requoteSubmission = async () => {
        const saveAndQuotePromise = LoadSaveService.updateQuotedSubmission(submissionVM.value, authHeader);

        showProgressDialog(messages.calculatingQuote, saveAndQuotePromise);

        let qdd;

        try {
            qdd = await saveAndQuotePromise;
        } catch(error){
            if (error.baseError && error.baseError.includes(messages.mvrDMVError.defaultMessage)){
                hideProgressDialog();
                showErrorModal(null, messages.mvrDMVError);
            }

            if (error.baseError && (error.baseError.includes(MVR_ERR1) || error.baseError.includes(MVR_ERR2) || error.baseError.includes(MVR_ERR3))) {
                hideProgressDialog();
                showErrorModal(null, messages.mvrUnavailableError);

                return;
            }

            MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
        }

        const newSubmissionVM = _.clone(submissionVM);

        _.set(newSubmissionVM, 'value', qdd);
        updateWizardData(newSubmissionVM);
    };

    const goToQuotePage = () => {
        const { steps, jumpTo } = wizardContext;
        const index = _.findIndex(steps, ({path}) => path === '/quote');
        // We must retrieve the full submission from PC so that we can update WizardData with the new status/disclosure found
        const requestData = {
            quoteID: submissionVM.quoteID.value,
            postalCode: submissionVM.baseData?.policyAddress?.postalCode?.value?.substring(0, 5)
        };
        const submissionLoadPromise = LoadSaveService.retrieveSubmission(requestData, authHeader);
        
        showProgressDialog(platformMessages.retrievingDraftSubmission, submissionLoadPromise);
        submissionLoadPromise.then((response) => {
            const newSubmissionVM = _.clone(submissionVM);

            _.set(newSubmissionVM, 'value', response);
            updateWizardData(newSubmissionVM);
            jumpTo(index);
        });
    }

    useEffect(() => { 
        if (goToQuotePageTrigger) {
            goToQuotePage();
        }
    }, [goToQuotePageTrigger]);


    const closeBlockQuoteUWErrorModal = () => {
        setGoToQuotePageTrigger(true)
    }

    const showBlockQuoteUWErrorModal = () => {
        const componentProps = {
            simpleMessage: translator(messages.blockQuoteError),
            actionBtnLabel: translator(messages.returnToQuote),
            showHeader: false,
            onCancelAction: closeBlockQuoteUWErrorModal
            
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const showColoradoCoverageErrorModal = () => {
        const componentProps = {
            simpleMessage: translator(messages.coloradoMandates),
            actionBtnLabel: translator(messages.coloradoMandatesAck),
            showHeader: false,
            onCancelAction:()=>setGoToQuotePageTrigger(true)
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />,
        )
    };

      const hasInvalidCostNew = () => {
    
            const vehicles = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicles.children',[]);

            return vehicles.some((vehicle) => {
                const costNewAmount = _.get(vehicle, 'costNew.value.amount') || 0;

                if(vehicle.category_ML.value.code === 'private_passenger_light_truck'){
                    return (!costNewAmount || costNewAmount <= 0);
                }

            });
        }
    
    const hasPrimaryNamedInsuredEmail = () => {  
        if (!isModernProductPersonalAuto || (deliveryType==='paper' && submissionVM?.bindData?.esignature_ML?.esignatureOptions?.value?.code !== 'Email' )
        ) {
            return true;
        }
        return (
            submissionVM.lobData.personalAuto.coverables.drivers?.value?.some((driver) => driver.relationshipToInsured_ML === 'self' &&
                !!driver.person?.emailAddress_ML?.trim()
            ) ?? false
        );
    }

    const checkForEsign = () => {
      clearBlockAlerts("missingEsign");
      clearBlockAlerts("missingEsignOption");
      clearBlockAlerts("missingMobileNumber");
      clearBlockAlerts("missingEsignAck")

      if (!isModernProduct || !isEsignEnabledForState) return false;

      let missingInfo = false;

      const eSign = _.get(
        submissionVM,
        "bindData.esignature_ML.esign_Ext.value",
      );

      const eSignOption = _.get(
        submissionVM,
        "bindData.esignature_ML.esignatureOptions.value.code",
      );

      const mobile = _.get(
        submissionVM,
        "bindData.esignature_ML.mobileNumber_Ext.value",
      );

      // esign is mandatory
      if (eSign == undefined || _.isUndefined(eSign)) {
        addErrorAlert(
          translator(messages.requiredFieldForEsign),
          "missingEsign",
        );
        missingInfo = true;
      }

      // eSignature Option is required when eSign = Yes

      if (eSign === true && !eSignOption) {
        addErrorAlert(
          translator(messages.requiredFieldForEsignOptions),
          "missingEsignOption",
        );
        missingInfo = true;
      }

      // Mobile is required when Text is selected
      if (eSignOption === "Text" && !mobile) {
        addErrorAlert(
          translator(messages.requiredField),
          "missingMobileNumber",
        );
            missingInfo = true;
        }

        //Acknowledgement is required when Text is selected
        if (eSign === true && eSignOption === 'Text') {
            const esignAck = _.get(submissionVM, `bindData.esignature_ML.esignTextAck_Ext.value`);
            if (_.isUndefined(esignAck) || esignAck == undefined) {
                addErrorAlert(
                    translator(messages.requiredFieldEsignAck),
                    "missingEsignAck",
                );
                missingInfo = true;
            }
        }

      return missingInfo;
    };
     const setDefaultManualPolicyNumber = () => {
       const lineModifiers = _.get(
         submissionVM,
         "lobData.personalAuto.modifiers_ML.lineModifiers.value",
         [],
       );

       lineModifiers.forEach((modifier) => {
         const isPolicyNumberModifier = multipolicyLobCodes.includes(
           modifier.codeIdentifier_ML,
         );

         const isEmpty =
           modifier.chosenTermValue === undefined ||
           modifier.chosenTermValue === null ||
           String(modifier.chosenTermValue).trim() === "";

         if (isPolicyNumberModifier && isEmpty) {
           modifier.chosenTermValue = "ManualMPD";
           modifier.isInputValueRequired_ML = false;
           modifier.savedFromPortal = true;
           modifier.updated = true;
           modifier.editMode_ML = true;
         }
       });

       updateWizardData(submissionVM);
     };
    const onNext = async () => {
        setDefaultManualPolicyNumber()
         
          if(checkForEsign()){
            window.scrollTo(0, 0);

            return false;
        }
        if(!checkForMandatoryFieldForSignalProgram()){
            updateShowErrors(true);
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 500);
            return false;
        }
        if(!hasNamedNonOwner && hasInvalidCostNew()){
            updateShowErrors(true);
            window.scrollTo(0, 0);
            
            return false;
        }

        if (!hasPrimaryNamedInsuredEmail()) {
            updateShowErrors(true);
            window.scrollTo(0, 0);
            return false;
        }

        if (hasDuplicateSignalPhoneNumbers(getRatedDrivers())) {
            addErrorAlert(messages.duplicateSignalPhoneNumberMessage, 'duplicateSignalPhone');
            
            return false;
        }

        const driversVM = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers');
        driversVM.forEach((driver) => {
            if (isRatedDriver(driver) || isExcludedDriver(driver)) {
                driver.value.isLicenseNumberRequired_ML = true;
            }
        });



        if (isGPA) {
            UserService.getCurrentUser(authHeader).then((user) => {
                PATrackEvent('Issuance Step Submitted', false, submissionVM, user, { step: 'Additional Info Prebind', action: 'Additional Information Prebind Submitted'});
            });
        }
        const emailValidationError = checkForEmailValidationError();
        removeAdditionalInterestEmailErrors();
        const valid = submissionVM.aspects.valid && submissionVM.aspects.subtreeValid;

       


        if (!valid) {
            updateShowErrors(true);
            setTimeout(()=>{
                setErrorTimestamp(errorTimestamp+1);
            }, 500);
            return false;
        }

        let isRequoted = false;
        if(hasSignalResponsesChanged()){
            isRequoted = true;
            await requoteSubmission();
        }

        const vehiclesVM = submissionVM.lobData.personalAuto.coverables.vehicles.children;

        if (!checkForUniqueLicenseNumbers() || checkForMissingAnnualMileage()) {
            return false;
        }

        if (submissionVM.aspects.valid && submissionVM.aspects.subtreeValid) {
            let errorMessages = [];
            if (!hasNamedNonOwner) {
                errorMessages = showVehicleOwnershipErrorMessages(vehiclesVM);
                if (vehiclesVM.some((vehicle) => checkVehicle(vehicle))) {
                    return;
                } 
            }

            if ((errorMessages.length === 0) || hasNamedNonOwner) {
                const canSkipSave = steps.some((step) => (step.mlStepName === 'paDisclosureReviewToBuy' || step.id === 'gwQuotePAPaymentDetailsPage')&& !!step.visited);

                saveCurrentPremium();

                if (!canSkipSave) {
                    showProgressDialog(platformMessages.saveSubmission);
                    _.set(submissionVM, 'portalCurrentStep_ML.value', 'paAddtlInfoToBuy');

                    try {
                        if(!isRequoted){
                            submissionVM.value = await LoadSaveService.updateQuotedSubmission(submissionVM.value, authHeader);
                        }

                        sortAdditionalInterestsByPublicID_Ext();
                        updateWizardSnapshot(submissionVM);
                    } catch (error) {
                        if (error.baseError.includes(BLOCK_QUOTE_UW_ERROR)) {
                            showBlockQuoteUWErrorModal();

                            return false;
                        }
                        
                        if (error.baseError && error.baseError.includes(messages.mvrDMVError.defaultMessage)){
                            showErrorModal(null, messages.mvrDMVError);
                            
                            return false;
                        }
         
                        if (error.baseError && error.baseError.includes(COVERAGE_IS_REQ)){                         
                            showColoradoCoverageErrorModal();
                            
                            return false;
                        }

                        MLErrorMessageUtil.handleException(error, showErrorModal, messages.somethingWentWrong);
                    } finally {
                        hideProgressDialog();
                    }
                }

                if (!shouldShowDisclosures()) {
                    const index = _.findIndex(
                        steps,
                        ({ path }) => path === '/disclosure-review-to-buy'
                    );
                    if (index > 0) {
                        const remainingSteps = _.slice(steps, index);
                        changeNextSteps(remainingSteps);
                    }
                } else {
                    const hasDisclosureReviewToBuyStep = steps.some((step) => step.path === '/disclosure-review-to-buy');
                    if (!hasDisclosureReviewToBuyStep) {
                        const disclosureReviewToBuyIndex = _.findIndex(
                            wizardSteps, ({ path }) => path === '/disclosure-review-to-buy'
                        );
                        const nextSteps = _.slice(wizardSteps, disclosureReviewToBuyIndex);
                        changeNextSteps(nextSteps);
                    }
                }
                if (!nextStepVisited()) {
                    return submissionVM;
                }
                goNext();
            } else {
                window.scrollTo(0, 0);
            }
        }
        return false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    };

    const resolvers = {
        resolveComponentMap: {
            addtlinterestdrivercomponent: AddtlInterestDriverComponent,
            addtlinterestexcludeddrivercomponent: AddtlInterestExcludedDriverComponent,
            mlScriptComponent: MLScriptComponent,
            esignatureComponent: EsignatureComponent,
            modifiercomponent: MLModifierComponent,
            questionset: QuestionSetComponent,
        },
        resolveCallbackMap: {
            onNext: onNext,
            
        }
    };

    return (
        <WizardPage
            showPrevious={false}
            showCancel={false}
            skipWhen={skipOnResumeIf}
            showNext={!nextStepVisited()}
            onNext={onNext}
            nextLabel={translator(platformMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited()}
            textNextToButton={getNextStepText()}
            metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
            stickyComponentOverrideId='stickyContinueSection'
            disableNext={inValidVin?.length > 0 || goToQuotePageTrigger}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                componentMap={resolvers.resolveComponentMap}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={styles}
                overrideProps={overrideProps}
                showErrors={showErrors}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
};

GatewayAdditionalInformationPreBindPage.propTypes = wizardProps;
export default GatewayAdditionalInformationPreBindPage;